import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslocoService } from '@ngneat/transloco';
import { BehaviorSubject, Observable } from 'rxjs';

interface Breadcrumb {
    path?: string[];
    title: string;
}

export interface Step {
    label: string;
    translate: boolean;
    children: Category[];
}

export interface Category {
    label: string;
    translate: boolean;
    children: Section[];
}

export interface Section {
    label: string;
    translate: boolean;
}

@Injectable({
    providedIn: 'root',
})
export class StepperService {
    private _steps: BehaviorSubject<Step[] | null> = new BehaviorSubject<
        Step[] | null
    >(null);

    private _index: BehaviorSubject<number | null> = new BehaviorSubject<
        number | null
    >(null);

    set steps(value: Step[] | null) {
        this._steps.next(value);
    }

    get steps$(): Observable<Step[] | null> {
        return this._steps.asObservable();
    }

    set index(value: number | null) {
        this._index.next(value);
    }

    get index$() {
        return this._index.asObservable();
    }

    constructor(
        private readonly _translocoService: TranslocoService,
        private readonly _documentTitle: Title
    ) { }
}
